import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useBlogs from '../hooks/useBlogs';
import useSEO from '../hooks/useSEO';
import SEOHead from '../components/SEOHead';
import Navbar1 from '../layout/Navbar1';

const BlogList: React.FC = () => {
  const { t } = useTranslation();
  const { blogs, loading, error } = useBlogs();
  const { seoData } = useSEO();

  if (loading) {
    return (
      <>
        <Navbar1 enableScrollEffect={false} className="bg-black" />
        <div className="container" style={{marginTop: '130px'}}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">{t('common.loading') || 'جاري التحميل...'}</p>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar1 enableScrollEffect={false} className="bg-black" />
        <div className="container" style={{marginTop: '130px'}}>
          <div className="alert alert-danger" role="alert">
            {t('common.error') || 'حدث خطأ'}: {error}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {seoData && <SEOHead seoData={seoData} />}
      <Navbar1 enableScrollEffect={false} className="bg-black" />
      <div className="container" style={{marginTop: '130px'}}>
        <h2 className="mb-4 text-center text-primary fw-bold">{t('blog.title') || 'المدونة'}</h2>
        <div className="row">
          {blogs.map((blog, index) => (
            <div className="col-12 col-md-6 col-lg-4 mb-4 d-flex" key={blog.id || index}>
              <div className="card h-100 shadow-sm border-0 w-100">
                <img 
                  src={blog.image} 
                  className="card-img-top"
                  alt={blog.title} 
                  style={{height: '221px', objectFit: 'cover'}}
                  onLoad={() => console.log('✅ Image loaded successfully:', blog.image)}
                
                />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title text-dark fw-semibold">{blog.title}</h5>
                  <p className="card-text text-muted flex-grow-1">
                    {blog.content.slice(0, 100)}...
                  </p>
                  <RouterLink 
                    to={`/blogs/${blog.id || index}`} 
                    className="btn btn-custom mt-2 align-self-end"
                    state={{ blog }}
                  >
                    {t('blog.readMore') || 'اقرأ المزيد'}
                  </RouterLink>
                </div>
              </div>
            </div>
          ))}
        </div>
        {blogs.length === 0 && (
          <div className="text-center py-5">
            <p className="text-muted">{t('blog.noPosts') || 'لا توجد مقالات متاحة حالياً'}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default BlogList; 